import { render, staticRenderFns } from "./OverviewNewZones.vue?vue&type=template&id=12da8cb8&scoped=true"
import script from "./OverviewNewZones.vue?vue&type=script&lang=ts"
export * from "./OverviewNewZones.vue?vue&type=script&lang=ts"
import style0 from "./OverviewNewZones.vue?vue&type=style&index=0&id=12da8cb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12da8cb8",
  null
  
)

export default component.exports